/**
 * @fileoverview Session Timeout Provider
 * @description Wraps app to enable auto-logout on inactivity.
 */

import { ReactNode } from 'react';
import { useSessionTimeout } from '@/hooks/useSessionTimeout';

export function SessionTimeoutProvider({ children }: { children: ReactNode }) {
  useSessionTimeout();
  return <>{children}</>;
}
